var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 666.41 726.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8787c2;\n      }\n      .skin-dark {\n        fill: #b09373;\n      }\n      .skin {\n        fill: #bb9f73;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M599.17,726.35H77.82C102.87,600.54,210.06,506,338.49,506S574.12,600.54,599.17,726.35Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "skin-dark",
    cx: 338.94,
    cy: 546.09,
    r: 76.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "skin",
    cx: 337.17,
    cy: 277.23,
    r: 277.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "skin",
    cx: 61.7,
    cy: 319.98,
    r: 61.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "skin",
    cx: 604.71,
    cy: 319.98,
    r: 61.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset2);
export default __webpack_public_path__ + "static/media/Asset 2.7aaac0c9.svg";
export { ForwardRef as ReactComponent };